import React, { useState } from "react";
import { faqs } from "../../mock";
import { SectionHeading } from "../SectionHeading";
import Reveal from "../Reveal";
import { Plus, Minus } from "lucide-react";

const FAQSection = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className="py-20 md:py-28 bg-[#08080f] relative overflow-hidden">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <SectionHeading eyebrow="Got Questions?" title="FAQs About" highlight="DaddyAnna" />
        <div className="space-y-4">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={f.q} delay={i * 60}>
                <div className={`rounded-xl border transition-colors ${isOpen ? "border-[#00ff87]/50 bg-[#0c0d17]" : "border-white/10 bg-[#0a0a13]"}`}>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 text-left px-5 py-4"
                  >
                    <span className="font-display font-medium text-white">{f.q}</span>
                    <span className={`shrink-0 h-8 w-8 grid place-items-center rounded-full ${isOpen ? "bg-[#00ff87] text-black" : "bg-[#12131f] text-[#00ff87]"}`}>
                      {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                    </span>
                  </button>
                  <div className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-40" : "max-h-0"}`}>
                    <p className="px-5 pb-5 text-gray-400 leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
